import type { VoicePreviewResponse } from "@uzverse/contracts";
import { PcmPlayer } from "./playback.js";
import type { PlayerAudioContext } from "./playback.js";

/**
 * Plays a `voice.preview` result: server voices return base64 `pcm_s16le`; browser voices
 * return the text and language the browser speaks itself.
 */
export function playPreview(
  preview: VoicePreviewResponse | void,
  env: { AudioContext?: new () => unknown; speechSynthesis?: SpeechSynthesis } = globalThis,
): boolean {
  if (!preview) return false;
  if (preview.audioBase64 && (preview.format ?? "pcm_s16le") === "pcm_s16le" && env.AudioContext) {
    const bytes = Uint8Array.from(atob(preview.audioBase64), (c) => c.charCodeAt(0));
    const pcm = new Int16Array(bytes.buffer, 0, Math.floor(bytes.byteLength / 2));
    const samples = Float32Array.from(pcm, (v) => v / 32768);
    const Ctx = env.AudioContext;
    new PcmPlayer(() => new Ctx() as PlayerAudioContext).enqueue(
      samples,
      preview.sampleRate ?? 22050,
    );
    return true;
  }
  if (preview.text && env.speechSynthesis && typeof SpeechSynthesisUtterance !== "undefined") {
    const u = new SpeechSynthesisUtterance(preview.text);
    if (preview.language) u.lang = preview.language;
    env.speechSynthesis.speak(u);
    return true;
  }
  return false;
}
